module.exports = __webpack_public_path__ + "static/media/silueta_irene.6a0dce08.png";